import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import IndexSection from './components/IndexSection';
import Updates from './components/Updates';
import Topics from './components/Topics';
import Media from './components/Media';
import Contact from './components/Contact';
import Ranking from './components/Ranking';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import FAQ from './components/FAQ';
import Comments from './components/Comments';
import AppDownload from './components/AppDownload';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <About />
        <IndexSection />
        <Updates />
        <Topics />
        <Media />
        <Contact />
        <Ranking />
        <CardsSection />
        <CarouselSection />
        <FAQ />
        <Comments />
        <AppDownload />
      </main>
      <Footer />
    </div>
  );
}